import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentsComponent } from './components/documents/documents.component';
import { DocumentoperationsComponent } from './components/documents/documentoperations/documentoperations.component';



const routes: Routes = [
	{ path: '', component: DocumentoperationsComponent }
	
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ]
})
export class DocumentsRoutingModule {}